/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Faq_A4Inputs */

const en_directory_home_faq_a4 = /** @type {(inputs: Directory_Home_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Sign in with the account that submitted the product and manage everything under My tools: details, updates, and takedowns.`)
};

const zh_directory_home_faq_a4 = /** @type {(inputs: Directory_Home_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。用提交产品的账号登录，在「我的工具」里即可管理一切：修改资料、发布更新或下架。`)
};

/**
* | output |
* | --- |
* | "Yes. Sign in with the account that submitted the product and manage everything under My tools: details, updates, and takedowns." |
*
* @param {Directory_Home_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_faq_a4 = /** @type {((inputs?: Directory_Home_Faq_A4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Faq_A4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_faq_a4(inputs)
	return zh_directory_home_faq_a4(inputs)
});
export { directory_home_faq_a4 as "directory.home.faq.a4" }